import { type FC, type PropsWithChildren } from "react";

export const DefaultLayout: FC<PropsWithChildren> = ({ children }) => {
	return <>{children}</>;
};
